import { render } from "./MainSettings.vue?vue&type=template&id=d748e0a0"
import script from "./MainSettings.vue?vue&type=script&lang=js"
export * from "./MainSettings.vue?vue&type=script&lang=js"

import "./MainSettings.vue?vue&type=style&index=0&id=d748e0a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__